import ml5 from "ml5";
import { useEffect, useState } from "react";
import squidgameDictionary from "../db/database";
import "./App.css";
import Loading from "./Loading";
import ResultChart from "./ResultChart";
import ResultContent from "./ResultContent";
import Share from "./Share";

function App() {
  const [inputImage, setInputImage] = useState(null);
  const [classifier, setClassifier] = useState(null);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [analyzeResults, setAnalyzeResults] = useState([]);

  useEffect(() => {
    //setClassifier from model.json
    const result = ml5.imageClassifier("model.json", () => {
      setClassifier(result);
    });
  }, []);

  const onInputImageChanged = (event) => {
    const {
      target: { files },
    } = event;
    if (files.length === 0) return;
    const theFile = files[0];
    const reader = new FileReader();
    reader.onloadend = (finishedEvent) => {
      const {
        currentTarget: { result },
      } = finishedEvent;
      setInputImage(result);
    };
    reader.readAsDataURL(theFile);
  };

  const onAnalyzeBtnClicekd = () => {
    if (classifier == null) return;

    setIsAnalyzing(true);
    const image = document.getElementById("uploadedImage");
    classifier.classify(image, (error, results) => {
      setIsAnalyzing(false);
      if (error) {
        console.log(error);
        setInputImage(null);
        return;
      }
      setAnalyzeResults(results);
    });
  };

  const onReuploadBtnClicked = () => {
    setInputImage(null);
    setAnalyzeResults([]);
  };

  const onRetryClicked = () => {
    setInputImage(null);
    setAnalyzeResults([]);
  };

  const findTheClosest = (results) => {
    const sorted = results.sort(
      (prev, cur) => cur.confidence - prev.confidence
    );
    return squidgameDictionary[sorted[0].label];
  };
  return (
    <div className="App">
      <img
        className="mainImage"
        src="/SquidGameFaceTestMain.png"
        alt="SquidGameFace"
      ></img>
      <div className="title">
        <span className="pinkLetter">S</span>QU
        <span className="pinkLetter">I</span>D
        <span className="pinkLetter">G</span>AME FACE TEST
      </div>
      <div className="subTitle">Who do I look like</div>
      <div className="subTitle">in Squid Game?</div>

      {inputImage === null ? (
        <>
          <label className="uploadPhoto" htmlFor="input-image">
            Upload Photo
          </label>
          <input
            id="input-image"
            type="file"
            accept="image/*"
            onChange={onInputImageChanged}
          ></input>
        </>
      ) : (
        <>
          {isAnalyzing ? (
            <>
              <Loading />
            </>
          ) : (
            <>
              {analyzeResults.length === 0 ? (
                <>
                  <img
                    className="uploadedPhoto"
                    src={inputImage}
                    alt="uploadedImage"
                    id="uploadedImage"
                  ></img>
                  <div className="imageBtns">
                    <button className="imageBtn" onClick={onAnalyzeBtnClicekd}>
                      Analyze
                    </button>
                    <button className="imageBtn" onClick={onReuploadBtnClicked}>
                      Re-Upload
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="resultImages">
                    <img
                      className="resultImage"
                      src={inputImage}
                      alt="resultImage"
                      id="resultImage"
                    ></img>
                    <img
                      className="resultImage"
                      src={`/characterImages/${
                        findTheClosest(analyzeResults).imageUrl
                      }`}
                      alt="resultImage"
                      id="resultImage"
                    ></img>
                  </div>
                  <ResultChart results={analyzeResults} />
                  <div className="imageBtns">
                    <button className="imageBtn" onClick={onRetryClicked}>
                      Retry
                    </button>
                  </div>
                  <ResultContent
                    closestCharObj={findTheClosest(analyzeResults)}
                  />
                </>
              )}
            </>
          )}
        </>
      )}
      <div className="referenceWords">* your photo won't be used anywhere</div>
      <Share />
      <footer>&copy; {new Date().getFullYear()} lefthanddeveloper</footer>
    </div>
  );
}

export default App;
